// LOGIN
export const LOGIN = '/login'

// RECOVERY
export const RECOVERY = '/p/reset-password/:hash'
export const FORGOT = '/forgot-password'

/**
 * CATALOG SECTION
 */
export const CATALOG = '/catalogo'

export const PRODUCTS = CATALOG + '/productos'
export const EDIT_SKU = PRODUCTS + '/editar-sku/:sku'
export const CREATE_PRODUCT = PRODUCTS + '/crear-producto'
export const CREATE_SKU = PRODUCTS + '/agregar-sku/:productId'
export const EDIT_PRODUCT = PRODUCTS + '/editar-producto/:productId'

export const BRANDS = CATALOG + '/marcas'
export const CREATE_BRAND = BRANDS + '/agregar'
export const EDIT_BRAND = BRANDS + '/editar/:brandId'

export const CATEGORIES = CATALOG + '/categorias'
export const CREATE_CATEGORY = CATEGORIES + '/agregar'
export const EDIT_CATEGORY = CATEGORIES + '/editar/:categoryId'

export const PROVIDERS = CATALOG + '/proveedores'
export const CREATE_PROVIDER = PROVIDERS + '/crear'
export const EDIT_PROVIDER = PROVIDERS + '/editar/:sellerId'

export const FACETS = CATALOG + '/facets'
export const CATEGORY_FACETS = CATALOG + '/asociar-facet-categoria'

export const MASSIVE_LOAD = CATALOG + '/actualizacion-masiva'

export const MILLENIUM_WARRANTY = CATALOG + '/garantia-milenia'
export const CREATE_EDIT_WARRANTY =
  MILLENIUM_WARRANTY + '/create-edit/:guaranteeId'
export const WARRANTY_CATEGORY = MILLENIUM_WARRANTY + '/garantias-categorias'
export const EXCLUDED_SKU = MILLENIUM_WARRANTY + '/excluir-skus'

// SECURITY
export const SECURITY = '/seguridad'
export const USERS = SECURITY + '/usuarios'
export const CREATE_USER = USERS + '/nuevo_usuario'
export const EDIT_USER = USERS + '/editar_usuario/:idUser'
export const PROFILES = SECURITY + '/perfiles'
export const CREATE_PROFILE = SECURITY + '/crear_perfil'
export const EDIT_PROFILE = SECURITY + '/editar_perfil/:id'

// REPORTS
export const REPORTS = '/reportes'
export const PRODUCT_CHANGE_LOG = REPORTS + '/bitacora-de-cambios'

// GIFT TABLE
export const GIFTTABLE = '/mesa-de-regalos'
export const EVENTS = GIFTTABLE + '/eventos'
export const CELEBRATED = GIFTTABLE + '/festejados'

// PROFILE
export const PROFILE = '/perfil'
export const ACCOUNT = PROFILE + '/cuenta'

// DASHBOARD
export const DASHBOARD = '/dashboard'
export const DETAIL = DASHBOARD + '/detalle'
export const DETAIL2P = DASHBOARD + '/detalle2/producto'
export const DETAIL2I = DASHBOARD + '/detalle2/imagenes'
export const DETAIL2F = DASHBOARD + '/detalle2/facets'
export const DETAIL3 = DASHBOARD + '/detalle3/:parametro'
export const DETAIL_SKU = DASHBOARD + '/detalleSKU'
